module.exports = __webpack_public_path__ + "img/93a0bae.png";